import React, {Component} from 'react'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap"
import FormOrderNumber from "./FormOrderNumber"
import {regenLabelByOrder, getInfoSettingBarcode} from "../../../../services/api/apiReGenerateLabel"
import PubSub from "pubsub-js"

class AddNewOrderNumber extends Component {
    constructor(props) {
        super(props)

        this.timeout = 0

        this.state = {
            string: '',
            barcodeNumber: '',
            label: '',
            weight: 0,
            volume: 0,
            reason: 'other',
            netWeight: 0,
            netVolume: 0,
            description: '',
            isOpen: false,
            loadingGetData: false,
            loadingRequestGenerate: false,
            errorGetData: '',
            errorRequestGenerate: '',
            barcode: '',
            shipping_carrier: ''
        }
    }

    _isOpen = () => {
        this.setState({
            isOpen: true
        })
    }

    _isClose = () => {
        this.setState({
            string: '',
            isOpen: false,
            barcodeNumber: '',
            label: '',
            weight: 0,
            volume: 0,
            reason: 'other',
            netWeight: 0,
            netVolume: 0,
            description: '',
            loadingGetData: false,
            loadingRequestGenerate: false,
            errorGetData: '',
            errorRequestGenerate: '',
            barcode: '',
            shipping_carrier: ''
        })
    }

    _validateOrderNumber = (string) => {
        if (string) {
            const regex = /[0-9]{6,}/
            const regex2 = /#?([0-9]{6,})(_[0-9]+)/
            const parsed = string.match(regex2)
            const parsed2 = string.match(regex)

            if (parsed !== null && parsed.length >= 3) {
                this.setState({
                    barcodeNumber: parsed[1]
                })

                return true
            } else if (parsed2 !== null && parsed2.length >= 1) {
                this.setState({
                    barcodeNumber: parsed2[0]
                })

                return true
            } else {
                this.setState({
                    errorGetData: 'Định dạng barcode number sai'
                })
            }
        } else {
            this.setState({
                errorGetData: 'Vui lòng nhập vào một barcode number'
            })
        }
    }

    _handleChangeData = (name, value) => {
        this.setState({
            [name]: value,
            loadingGetData: false,
            loadingRequestGenerate: false,
            errorGetData: '',
            errorRequestGenerate: ''
        })
    }

    _fetchDataOrder = async () => {
        this.setState({
            loadingGetData: true,
            errorGetData: ''
        })

        try {
            const {barcodeNumber} = this.state

            const {data: response} = await getInfoSettingBarcode(barcodeNumber)

            const {success, message, data} = response

            if (!success) {
                return this.setState({
                    loadingGetData: false,
                    errorGetData: message
                })
            }

            this.setState({
                loadingGetData: false,
                weight: data.weight,
                volume: data.weight_by_v,
                label: !!data.labelDetails ? (!!data.labelDetails.partnerTrackingNumber ? data.labelDetails.partnerTrackingNumber : null) : null,
                barcode: data.barcode
            })
        } catch (e) {
            this.setState({
                loadingGetData: false,
                errorGetData: e.message
            })
        }
    }

    _requestReGenerateLabel = async () => {
        this.setState({
            loadingRequestGenerate: true,
            errorRequestGenerate: ''
        })
        try {
            const {
                barcodeNumber,
                reason,
                netWeight,
                netVolume,
                description,
                weight,
                volume,
                shipping_carrier,
                shipping_level
            } = this.state
            const payload = {
                barcode_number: barcodeNumber,
                reason: reason,
                net_weight: parseFloat(netWeight),
                net_volume: parseFloat(netVolume),
                content: description,
                setting_weight: weight,
                setting_volume: volume,
                force_error: false,
                shipping_carrier: shipping_carrier,
                shipping_level
            }
            const {data: response} = await regenLabelByOrder(payload)

            const {success, message} = response

            if (!success) {
                return this.setState({
                    loadingRequestGenerate: false,
                    errorRequestGenerate: message
                })
            }

            this.setState({
                loadingRequestGenerate: false,
            }, () => {
                this._isClose()
                const {resetListRegenLabel} = this.props

                if (typeof resetListRegenLabel === 'function') {
                    resetListRegenLabel()
                }

                PubSub.publish('LIST_RE_GENERATE_SIDEBAR')
            })
        } catch (e) {
            this.setState({
                loadingRequestGenerate: false,
                errorRequestGenerate: e.message
            })
        }
    }

    _onGetDataOrder = (value) => {
        this.setState({
                string: value,
                errorGetData: '',
                label: '',
                weight: 0,
                volume: 0,
            }, () => {
                const {string} = this.state

                if (this.timeout) clearTimeout(this.timeout)

                this.timeout = setTimeout(() => {
                    const validate = this._validateOrderNumber(string)

                    if (validate) {
                        this._fetchDataOrder()
                    }
                }, 1000)
            }
        )
    }

    _onRequestGenerateLabel = () => {
        const {netWeight, reason} = this.state

        if (!netWeight && reason === 'other') {
            this.setState({
                errorRequestGenerate: 'Vui lòng nhập thông tin cân nặng thực tế trước khi generate.'
            })
        } else {
            this._requestReGenerateLabel()
        }
    }

    render() {
        const {
            isOpen,
            barcodeNumber,
            label,
            weight,
            volume,
            reason,
            netWeight,
            netVolume,
            description,
            string,
            shipping_carrier,
            shipping_level
        } = this.state
        const {errorGetData, loadingGetData, loadingRequestGenerate, errorRequestGenerate} = this.state

        return (
            <div className='AddNew mr-3'>
                <Button color='primary' onClick={this._isOpen}><i className='fa fa-plus mr-1'/>Thêm mới</Button>
                <Modal isOpen={isOpen} toggle={this._isClose} size='lg' autoFocus={false}>
                    <ModalHeader toggle={this._isClose}>Generate lại label</ModalHeader>
                    <ModalBody>
                        <FormOrderNumber
                            loadingGetData={loadingGetData}
                            errorGetData={errorGetData}
                            string={string}
                            label={label}
                            weight={weight}
                            volume={volume}
                            reason={reason}
                            realityWeight={netWeight}
                            realityVolume={netVolume}
                            description={description}
                            shipping_carrier={shipping_carrier}
                            shipping_level={shipping_level}
                            onChangeData={this._handleChangeData}
                            onGetDataOrder={this._onGetDataOrder}
                        />
                    </ModalBody>
                    <ModalFooter className='d-flex align-items-center justify-content-between'>
                        <Button color="secondary" onClick={this._isClose}>Hủy bỏ</Button>
                        <div className='d-flex align-items-center'>
                            {errorRequestGenerate && <div className='text-danger mr-2'>{errorRequestGenerate}</div>}
                            <Button
                                color="primary"
                                disabled={!barcodeNumber || !!errorGetData}
                                onClick={this._onRequestGenerateLabel}
                            >
                                {loadingRequestGenerate && <i className='fa fa-spin fa-spinner mr-1'/>}
                                Generate label
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

export default AddNewOrderNumber
